// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"c4fb18ab","453":"6d2005b8"}[chunkId] + ".chunk.js";
};